import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import LoginFormModal from '../LoginFormModal';
import LogOutFormModal from '../LogOutFormModal';
import AgeConfirmModal from '../AgeConfirmModal';
import ShippingModal from '../ShippingModal';
import ProductModal from '../ProductModal';
import SignUpFormModal from '../SignUpFormModal';
import HelpPage from '../HelpPage';
import OrdersPage from '../OrdersPage';
import MyAccount from '../MyAccount';
import NotificationsPage from '../NotificationsPage';
import MembershipPage from '../MembershipAgreementPage';
import SignUpConfirmModal from '../SignUpConfirmModal';
import ConfirmModal from '../ConfirmModal';
import ChooseBankAccountModal from '../ChooseBankAccountModal';
import SignUpAuthConfirmModal from '../SignUpAuthConfirmModal';
import OrderCompleteModal from '../OrderCompleteModal';
import ProductAddedToCartModal from '../ProductAddedToCartModal';
import LoginInfoModal from '../LoginInfoModal';
import AddressesPage from '../AddressesPage';
import EditAddressModal from '../EditAddressModal';
import FilterBar from '../FilterBar';
import SignUpErrorModal from '../SignUpErrorModal';
import UploadInfoModal from '../UploadInfoModal';
import HowDidYouHearModal from '../HowDidYouHearModal';
import PasswordFormModal from '../PasswordFormModal';
import AddAddressModal from '../AddAddressModal';
import ChangedPasswordFormModal from '../ChangedPasswordFormModal';
import ResetPasswordModal from '../ResetPasswordModal';
import CheckoutErrorModal from '../CheckoutErrorModal';
import SignupCancelledModal from '../SignupCancelledModal';
import GenericdModal from '../GenericModal';
import KioskDisabledModal from '../KioskDisabledModal/KioskDisabledModal';
import KioskOrderFormModal from '../KioskOrderModal/KioskOrderFormModal';
import KioskOrderCompleteModal from '../KioskOrderCompleteModal/KioskOrderCompleteModal';
import KioskLoginFormModal from '../KioskLoginForm/KioskLoginFormModal';
import PaymentKioskOrderCompleteModal from '../PaymentKioskOrderCompleteModal/PaymentKioskOrderCompleteModal';
import PurchaseLimitsContainer from '../PurchaseLimitsModal/PurchaseLimitsContainer';
import SmallModal from '../SmallModal/small_modal_container';
import MessageModal from '../MessageModal';
import EmailUpdateFormModal from '../EmailUpdateFormModal/EmailUpdateFormModal';
import EmailUpdateConfirmationModal from '../EmailUpdateConfirmationModal/EmailUpdateConfirmationModal';
import { EMAIL_CONFIRMATION_MODAL, EMAIL_UPDATE_FORM } from '../../actions/modal';
import ReachOutUsToResetPasswordModal from '../ResetPasswordModal/ReachOutUsToResetPasswordModal';
import MsoPaymentIframeModal from '../MsoPaymentModal/MsoPaymentIframeModal';

const MODAL_COMPONENTS = {
  LOGIN_FORM: LoginFormModal,
  LOGOUT_FORM: LogOutFormModal,
  SIGNUP_FORM: SignUpFormModal,
  AGE_CONFIRM_FORM: AgeConfirmModal,
  CONFIRM_MODAL: ConfirmModal,
  CHOOSE_BANK_ACCOUNT_MODAL: ChooseBankAccountModal,
  SHIPPING_FORM: ShippingModal,
  '1X_PRODUCT_VIEW': ProductModal,
  HELP_PAGE: HelpPage,
  ORDERS_PAGE: OrdersPage,
  MY_ACCOUNT_PAGE: MyAccount,
  NOTIFICATIONS_PAGE: NotificationsPage,
  MEMBERSHIP_PAGE: MembershipPage,
  SIGNUP_CONFIRM_FORM: SignUpConfirmModal,
  SIGNUP_AUTH_CONFIRM_FORM: SignUpAuthConfirmModal,
  KIOSK_ORDER_FORM: KioskOrderFormModal,
  ORDER_COMPLETE_FORM: OrderCompleteModal,
  KIOSK_ORDER_COMPLETE_FORM: KioskOrderCompleteModal,
  PAYMENT_KIOSK_ORDER_COMPLETE_FORM: PaymentKioskOrderCompleteModal,
  ITEM_ADDED_FORM: ProductAddedToCartModal,
  LOGIN_INFO_FORM: LoginInfoModal,
  ADDRESSES_PAGE: AddressesPage,
  EDIT_ADDRESS_FORM: EditAddressModal,
  FILTER_MODAL: FilterBar,
  SIGN_UP_ERROR: SignUpErrorModal,
  UPLOAD_INFO: UploadInfoModal,
  HOW_DID_YOU_HEAR: HowDidYouHearModal,
  PASSWORD_FORM: PasswordFormModal,
  ADD_ADDRESS: AddAddressModal,
  CHANGE_PASSWORD_FORM: ChangedPasswordFormModal,
  [EMAIL_UPDATE_FORM]: EmailUpdateFormModal,
  [EMAIL_CONFIRMATION_MODAL]: EmailUpdateConfirmationModal,
  RESET_PASSWORD_FORM: ResetPasswordModal,
  REACH_OUT_US_RESET_PASSWORD: ReachOutUsToResetPasswordModal,
  CHECKOUT_ERROR: CheckoutErrorModal,
  SIGNUP_CANCELLED: SignupCancelledModal,
  GENERIC: GenericdModal,
  KIOSK_DISABLED_FORM: KioskDisabledModal,
  KIOSK_LOGIN_FORM: KioskLoginFormModal,
  PURCHASE_LIMITS_FORM: PurchaseLimitsContainer,
  SMALL_MODAL: SmallModal,
  MESSAGE_MODAL: MessageModal,
  MSO_PAY_IFRAME_MODAL: MsoPaymentIframeModal,
  /* other modals */
};

class ModalRoot extends Component {
  shouldComponentUpdate(nextProps) {
    const {
      modalType,
      modalProps,
    } = this.props;

    return modalType !== nextProps.modalType || modalProps !== nextProps.modalProps;
  }

  renderModal = () => {
    const {
      modalType,
      modalProps,
    } = this.props;

    if (!modalType) {
      return null;
    }

    const SpecificModal = MODAL_COMPONENTS[modalType];

    return <SpecificModal {...modalProps} />;
  };

  render() {
    return <div>{this.renderModal()}</div>;
  }
}

ModalRoot.defaultProps = {
  modalType: undefined,
  modalProps: undefined,
};

ModalRoot.propTypes = {
  modalType: PropTypes.string,
  modalProps: PropTypes.shape({}),
};

const mapStateToProps = state => ({
  modalType: state.modal.modalType,
  modalProps: state.modal.modalProps,
});

export default connect(mapStateToProps, {})(ModalRoot);



// WEBPACK FOOTER //
// ./src/components/ModalRoot/ModalRoot.jsx